import React from 'react';
import { mergeClassLists } from 'tailwind-classlist';
import { classes } from './utils';

export default function Section({ className = '', ...props }) {
  return (
    <div className={mergeClassLists(classes.section, className)} {...props} />
  );
}
